module.exports = __webpack_public_path__ + "static/img/img05.c55536a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en001/img05.jpg
// module id = i5cA
// module chunks = 0